import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react'
import { ModalComponentProps } from '@qse/constants'
import React from 'react'

const QuotaExceededModal: React.FC<ModalComponentProps> = ({
  toggleModel,
  setToggleModel,
  onClose,
}) => {
  const handleClose = () => {
    setToggleModel(false)
    if (onClose) {
      onClose()
    }
  }

  return (
    <Modal backdrop="blur" isOpen={toggleModel} size="md" onClose={handleClose}>
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
              <svg
                className="w-5 h-5 text-red-600 dark:text-[#DD524C]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                />
              </svg>
            </div>
            <span className="text-lg font-semibold">Quota Exceeded</span>
          </div>
        </ModalHeader>
        <ModalBody className="pb-4">
          <div className="space-y-4">
            <p className="text-gray-600 dark:text-gray-300">
              You have reached your current plan's quota limit. To continue generating quantum
              entropy and noise proof, please contact your admin to upgrade your plan.
            </p>
            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-yellow-600 dark:text-yellow-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                </svg>
                <div>
                  <h4 className="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                    What happens when you upgrade?
                  </h4>
                  <ul className="mt-2 text-sm text-yellow-700 dark:text-yellow-300 space-y-1">
                    <li>• Higher quota limits for entropy generation</li>
                    <li>• Access to premium quantum entropy sources</li>
                    <li>• Priority support and faster response times</li>
                    <li>• Advanced security features</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onPress={handleClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default QuotaExceededModal
